// Libs
import React from 'react';
// Components
import OrdersOverview from '../OrdersOverview/OrdersOverview';

const OrdersPending = props => (
	<OrdersOverview {...props} orderFlowType='orders_pending' />
);
export default OrdersPending;
